var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoicon9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_6684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9975 0.788086C14.329 0.788086 0 15.1151 0 32.7896C0 46.926 9.16827 58.921 21.8843 63.1545C23.4854 63.4474 24.0689 62.4591 24.0689 61.6104C24.0689 60.8502 24.041 58.8385 24.0243 56.1688C15.1232 58.1018 13.2452 51.8785 13.2452 51.8785C11.7895 48.1813 9.69144 47.1971 9.69144 47.1971C6.78596 45.213 9.9114 45.2521 9.9114 45.2521C13.1233 45.4782 14.8128 48.5505 14.8128 48.5505C17.6672 53.4401 22.3033 52.0278 24.1264 51.2086C24.4171 49.1419 25.2442 47.7314 26.1576 46.9318C19.0522 46.1225 11.5812 43.3781 11.5812 31.1158C11.5812 27.621 12.8287 24.7666 14.8756 22.5291C14.5454 21.7197 13.4475 18.4664 15.1903 14.0601C15.1903 14.0601 17.8757 13.1997 23.9892 17.3389C26.541 16.6297 29.2795 16.2761 32.0003 16.2624C34.7192 16.2735 37.4557 16.6299 40.0114 17.3389C46.121 13.1997 48.8025 14.0601 48.8025 14.0601C50.5489 18.4664 49.4508 21.7197 49.1227 22.5291C51.1736 24.7666 52.4112 27.621 52.4112 31.1158C52.4112 43.4095 44.9285 46.1145 37.8014 46.9062C38.9486 47.8943 39.9721 49.8471 39.9721 52.8332C39.9721 57.1098 39.9331 60.5614 39.9331 61.6104C39.9331 62.4669 40.5107 63.463 42.1334 63.1506C54.8396 58.9093 64 46.924 64 32.7896C64 15.1151 49.6719 0.788086 31.9975 0.788086Z",
    fill: "#1B1817"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_6684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoicon9);
export default __webpack_public_path__ + "static/media/logoicon9.368082bfa32a0a50dd85a0362fc9a1b4.svg";
export { ForwardRef as ReactComponent };